import { AuthConfig, AuthProviderType, IAuthProvider } from "../interfaces/IAuthProvider";
import { KeycloakProvider } from "../providers/KeycloakProvider";
import { OAuth2CapacitorProvider } from "../providers/OAuth2CapacitorProvider";
import { DeviceAuthProvider } from "../providers/DeviceAuthProvider";

export class AuthProviderFactory {
  static createProvider(type: AuthProviderType, config: AuthConfig): IAuthProvider {
    switch (type) {
      case "keycloak":
        return new KeycloakProvider(config);
      case "oauth2-capacitor":
        return new OAuth2CapacitorProvider(config);
      case "device-auth":
        return new DeviceAuthProvider(config);
      default:
        throw new Error(`Unknown provider type: ${type}`);
    }
  }

  static getConfigFromEnv(configKey = "VITE_KC_AUTH_CONFIG"): AuthConfig {
    const kcConfig = JSON.parse(import.meta.env[configKey] || "{}");
    return {
      serverUrl: kcConfig.serverUrl,
      realm: kcConfig.realm,
      clientId: kcConfig.clientId,
    };
  }
}
